import { VFooter } from 'vuetify/lib/components/VFooter';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VFooter,{staticStyle:{"z-index":"3"},attrs:{"dark":"","color":"#f5f5f5"}},[_c('div',{staticClass:"body-1 font-weight-light text-center text-lg-right",staticStyle:{"width":"100%","color":"#333"}},[_vm._v(" "+_vm._s(_vm.getVersion())+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }